export default function configs(state = [], action) {
    console.log("entrei aqui 4")
    switch (action.type) {

        case 'ADD_CURRENT':
            return {
                ...state,
                config: action.config,
            }

        case 'UPDATE_CONFIG_CALLEDS':
            console.log("entrei aqui 2")
            console.log(state)
            console.log(action)
            console.log(state.config.configcalleds)
            if (state.config && state.config.configcalleds) {
                return {
                    ...state,
                    config: {
                        ...state.config,
                        configcalleds: {
                            ...state.config.configcalleds,
                            enableautomaticcalledtagging: action.enableautomaticcalledtagging,
                            enabletagsoncalleds: action.enabletagsoncalleds,
                            applyinternalexpirationvalidation: action.applyinternalexpirationvalidation,
                        }

                    }
                }
            } else {
                return {
                    ...state,
                    config: {
                        ...state.config,
                    }
                }
            }

        case 'UPDATE_CONFIG_ARTICLES':

            if (state.config && state.config.configarticles) {
                return {
                    ...state,
                    config: {
                        ...state.config,
                        configarticles: {
                            ...state.config.configarticles,
                            enabletagsonarticles: action.enabletagsonarticles,

                        }

                    }
                }
            } else {
                return {
                    ...state,
                    config: {
                        ...state.config,
                    }
                }
            }


        case 'UPDATE_CONFIG_USERS':

            if (state.config && state.config.configusers) {
                return {
                    ...state,
                    config: {
                        ...state.config,
                        configusers: {
                            ...state.config.configusers,
                            enabletagsonusers: action.enabletagsonusers,

                        }

                    }
                }
            } else {
                return {
                    ...state,
                    config: {
                        ...state.config,
                    }
                }
            }

        default:
            console.log("entrei aqui 3")
            return state;
    }
}
